// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorFallback_wrapper__FI2Ef","errorContent":"ErrorFallback_errorContent__m8rBU"};